(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-reviews')) {
    class CustomerReviews extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        if (this.dataset.mobileColumns !== '2') {
          this.classList.add('customer-reviews--ready');
          return;
        }

        this.querySelectorAll('[data-review-copy]').forEach((copy) => {
          const full = copy.querySelector('[data-review-full]');
          const preview = copy.querySelector('[data-review-preview]');
          const excerpt = copy.querySelector('[data-review-excerpt]');
          const toggle = copy.querySelector('[data-review-toggle]');

          if (!full || !preview || !excerpt || !toggle) return;

          const text = full.textContent.replace(/\s+/g, ' ').trim();

          if (text.length <= 80) return;


          let previewText = text.slice(0, 80);
          const lastSpace = previewText.lastIndexOf(' ');

          if (lastSpace > 0) {
            previewText = previewText.slice(0, lastSpace);
          }

          excerpt.textContent = previewText;
          copy.dataset.truncated = 'true';

          if (!/^[.…]/.test(toggle.textContent.trim())) {
            toggle.classList.add(
              'customer-reviews__expand-button--spaced'
            );
          }
        });

        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-review-toggle]');

          if (!toggle || !this.contains(toggle)) return;

          const copy = toggle.closest('[data-review-copy]');

          if (!copy) return;

          copy.classList.add('is-expanded');
          toggle.setAttribute('aria-expanded', 'true');
        });

        this.addEventListener('keydown', (event) => {
          const toggle = event.target.closest('[data-review-toggle]');

          if (!toggle || !this.contains(toggle)) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;

          event.preventDefault();
          toggle.click();
        });

        this.classList.add('customer-reviews--ready');
      }
    }

    customElements.define('customer-reviews', CustomerReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
